import React from 'react';
import BoardItem from '@amzn/awsui-board-components/board-item';
import { Card, CardBaseProps, CardHeader, i18nStrings, NavigableDiv } from './Card';
import { TransferIcon } from '../Home/Icons';

import styles from './Card.module.scss';
import { PurchaseLineCountType, useCards } from './hooks/useCards.hook';

export const ReceivePOLines = ({ onPanelChange }: CardBaseProps) => {
    const { data, isPending, error } = useCards().usePurchaseLineCount(PurchaseLineCountType.PENDING_RECEIVING);

    return (
        <BoardItem
            i18nStrings={i18nStrings}
            header={
                <CardHeader dataHeaderId={Card.ReceivePOLines} onPanelChange={onPanelChange}>
                    <TransferIcon />
                    <span className={styles.iconText}>Receive PO lines</span>
                </CardHeader>
            }
        >
            <NavigableDiv
                dataLinkId={Card.ReceivePOLines}
                url="/receiving?statuses=partially_received|||no_receiving"
                isPending={isPending}
                error={error}
            >
                You have <b>{data} PO lines</b> that need to be received
            </NavigableDiv>
        </BoardItem>
    );
};
